import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ConsentType } from 'app/model/user/consent-model';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { UserService } from 'app/services/user/user.service';
import { Subscription } from 'rxjs/Subscription';
import { consentName } from 'environments/properties';


@Component({
  selector: 'act-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent implements OnInit, OnDestroy {

  public contentFromAPI: string;
  private getConsentDetailSubscription: Subscription;
  private langSubscription: Subscription;

  @Input() lang: string;
  @Input() content: string;
  @Input() isGetContentFromAPI = false;

  constructor(
    private appConfigService: AppConfigService,
    private userService: UserService
  ) {
    this.lang = this.appConfigService.getLanguage();
  }

  ngOnInit() {
    this.langSubscription && this.langSubscription.unsubscribe();
    this.langSubscription = this.appConfigService.getLanguageObs().subscribe(lang => {
      this.lang = lang;
      this.getConsentDetail(consentName, this.lang);
    });

    if (this.isGetContentFromAPI) {
      this.getConsentDetail(consentName, this.lang);
    }
  }

  ngOnDestroy() {
    this.langSubscription && this.langSubscription.unsubscribe();
    this.getConsentDetailSubscription && this.getConsentDetailSubscription.unsubscribe();
  }

  getConsentDetail(consentName: string, lang: string) {
    this.getConsentDetailSubscription && this.getConsentDetailSubscription.unsubscribe();
    this.getConsentDetailSubscription = this.userService.getConsentDetail(consentName, ConsentType.TERMS, lang)
      .subscribe(
        res => {
          if (res) {
            this.contentFromAPI = res.terms;
          }
        },
        err => console.error(err)
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/terms-and-conditions/terms-and-conditions.component.ts